<template>
  <div class="seatAssistant TopHeadder">
      <!-- 坐席助手 -->
      <div class="bannerBox">
          <img src="../../assets/image/banner-seatAssistant.jpg" />
      </div>

      <div class="PublicPadding">
          <h4 class="title">功能介绍</h4>
          <div class="PublicUl">
              <ul class="clear PublicStyle">
                  <li>
                      <i><img src="../../assets/image/home_siludaohang.png" /></i>
                      <h6>思路导航</h6>
                      <p>梳理成熟销售思路，指导销售沟通逻辑</p> 
                  </li>
                  <li>
                      <i><img src="../../assets/image/home_huashu.png" /></i>
                      <h6>智能话术</h6>
                      <p>语义理解读懂客户，提供最佳沟通话术</p> 
                  </li>
                  <li>
                      <i><img src="../../assets/image/home_yuyinzhijian.png" /></i>
                      <h6>语音质检</h6>
                      <p>通话过程实时质检，提醒销售表述漏洞</p> 
                  </li>
                  <li>
                      <i><img src="../../assets/image/home_yonghuhuaxiang.png" /></i>
                      <h6>用户画像</h6>
                      <p>全方位多角度采集，自动记录用户画像</p> 
                  </li>
              </ul>
          </div>
      </div>

      <div class="PublicPadding mTop20">
          <h4 class="title">应用价值</h4>
          <ul class="ulType5">
              <li>
                  <img src="../../assets/image/seat_value_pic1.jpg" class="li_pic">
                  <p class="li_tit">辅助坐席，提升服务效率</p>
                  <p class="li_txt">实时辅助坐席，提示客户问题的有效应答方案，提升坐席人员的服务效率</p>
              </li>
              <li>
                  <img src="../../assets/image/seat_value_pic2.jpg" class="li_pic">
                  <p class="li_tit">实时监控，降低运营风险</p>
                  <p class="li_txt">实时监控坐席，预警需人工座席处理或实时质检的特殊业务，降低运营风险</p>
              </li>
              <li>
                  <img src="../../assets/image/seat_value_pic3.jpg" class="li_pic">
                  <p class="li_tit">实时分析，提升客户满意度</p>
                  <p class="li_txt">对客户提出的问题进行实时分析，提醒座席人员及时跟进，提升客户满意度</p>
              </li>
              <li>
                  <img src="../../assets/image/seat_value_pic4.jpg" class="li_pic">
                  <p class="li_tit">缩短培训周期，降低成本</p>
                  <p class="li_txt">有效提升坐席业务技能，缩短培训周期，降低人力成本，提高公司业绩</p>
              </li>
          </ul>
      </div>
       <Popup v-show="$store.state.isshow"></Popup>
  </div>
</template>

<script>
import Popup from "@/components/popup"
export default {
  name: 'seatAssistant',
  data () {
    return {
      
    }
  },
  components:{
       Popup
  },
   methods:{
      popup(){
       this.$store.commit("openPop",{isopen:true,type:1})
    },
  
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/product/seatAssistant.vue